<template>
  <div class="home">
    <LoginDialog/>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginDialog from '@/components/login/LoginDialog.vue'

export default {
  name: 'Home',
  components: {
    LoginDialog
  }
}
</script>
